import { createContext, FC } from 'react';

import { WizardContextType, WizardProviderProps } from './types';

export const WizardContext = createContext<WizardContextType>({} as WizardContextType);

const WizardProvider: FC<WizardProviderProps> = ({ children, value }) => {
	return <WizardContext.Provider value={value}>{children}</WizardContext.Provider>;
};

export default WizardProvider;
